angular.module("app").service('LazyLoading', [
    '$q',
    '$http',
    '$rootScope',
    'appConstants',
    function ($q, $http, $rootScope, appConstants) {

        var getFilePaths = function (permissions) {
            var deffered = $q.defer();

            $http.get('app/global/data/permFileMap.json').success(function (data) {
                var permissionFileMap = data;
                var returnArray = [];
                if (jQuery.inArray(appConstants.Permissions.SuperUser, permissions) != -1) {
                    var superUserArray = jQuery.map(permissionFileMap, function (itm, ind) {
                        return itm.filePath;
                    });
                    deffered.resolve(superUserArray);
                }
                else {
                    angular.forEach(permissions, function (item) {
                        var tempItems = jQuery.grep(permissionFileMap, function (el) {
                            return el.permissionName == item;
                        });
                        if (tempItems.length > 0) {
                            var concatArray = jQuery.map(tempItems, function (itm, ind) {
                                return itm.filePath;
                            });
                            returnArray = returnArray.concat(concatArray);
                            //returnArray.push(tempItems[0].filePath);
                        }
                    });
                    var withoutPermsArray = jQuery.grep(permissionFileMap, function (el) {
                        return el.permissionName == "";
                    });
                    var withoutPermsConcatArray = jQuery.map(withoutPermsArray, function (itm, ind) {
                        return itm.filePath;
                    });
                    returnArray = returnArray.concat(withoutPermsConcatArray);
                    deffered.resolve(returnArray);
                }
            });

            return deffered.promise;
        }

        var getMenu = function (menuItems) {
            var returnItems = angular.copy(menuItems);
            var permissions = $rootScope.PermissionStorage || [{IsSuperUserVisible: true}];
            angular.forEach(returnItems, function (item) {
                var tempItem = jQuery.grep(permissions, function (el) {
                    if(item.IsSuperUserVisible)
                        return el == item.Permission || el == appConstants.Permissions.SuperUser;
                    else
                        return el == item.Permission
                });
                if (tempItem.length == 0) {
                    item.Visible = true;
                }

                if (item.Submenu != null) {
                    item.Submenu = getMenu(item.Submenu);
                }
            });
            return returnItems;
        }

        return {
            lazyLoadFiles: function (perms) {
                var deffered = $q.defer();
                getFilePaths(perms).then(function (files) {
                    require(files,
                        function () {
                        },
                        function (err) {
                            var failedId = err.requireModules && err.requireModules[0];
                            requirejs.undef(failedId);
                        });
                    deffered.resolve();
                });
                return deffered.promise;
            },
            getMenuJson: function (menuJson) {
                var retVal = getMenu(menuJson);
                return retVal;
            }
        };
    }
]);


angular.module('app').factory('translationLazyLoader', function ($http, $q)
{
    return function (options)
    {
        var deferred = $q.defer();
        $http({
            method: 'GET',
            url: './resources/languages/' + options.key + '.json'
        }).success(function (data)
        {
            deferred.resolve(data);
        }).error(function ()
        {
            deferred.reject(options.key);
        });

        return deferred.promise;
    };
});

angular.module('app').config([
    '$translateProvider',
    function ($translateProvider)
    {
        $translateProvider.useLoader('translationLazyLoader', {});
    }
]);

angular.module('app').config([
    '$translateProvider',
    function ($translateProvider)
    {
        $translateProvider.useLocalStorage();

        $translateProvider.fallbackLanguage([
            'en',
            'ru'
        ]);

        $translateProvider.useStaticFilesLoader({
            prefix: './resources/languages/',
            suffix: '.json'
        });
        $translateProvider.preferredLanguage('en');

    }
]);